import { render, staticRenderFns } from "./PlayerPicture.vue?vue&type=template&id=1c1e805d&"
import script from "./PlayerPicture.vue?vue&type=script&lang=js&"
export * from "./PlayerPicture.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports